import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCircleExclamation, faInfoCircle, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import React from "react";
import "./hint.scss";

interface IHintOwnProps {
    severity: HintSeverity;
    color: HintColor;
}

interface IHintProps extends IHintOwnProps, Omit<React.ComponentPropsWithoutRef<"div">, keyof IHintOwnProps> { }

export const Hint = (props: IHintProps) => {
    const { children, severity, color, ...restProps } = props;

    return (
        <div
            {...restProps}
            className={clsx(
                "farmact-hint",
                {
                    "farmact-hint--primary": color === "primary",
                    "farmact-hint--light": color === "light",
                    "farmact-hint--warning": color === "warning",
                    "farmact-hint--danger": color === "danger",
                },
                restProps.className
            )}>
            <FontAwesomeIcon icon={getSeverityIcon(severity)} className="farmact-hint__icon" />
            <div className="farmact-hint__content">{children}</div>
        </div>
    );
};

export type HintSeverity = "info" | "warning" | "error";
export type HintColor = "light" | "primary" | "warning" | "danger";

function getSeverityIcon(severity: HintSeverity): IconProp {
    switch (severity) {
        case "info":
            return faInfoCircle;
        case "warning":
            return faTriangleExclamation;
        case "error":
            return faCircleExclamation;
    }
}
